import home from '@/components/home/home.vue'
//jm-平台管理员
import jmPlatform from '@/components/home/jm/platform/home.vue'
import jmPlatformShangpingtongjiHome from '@/components/home/jm/platform/shangpingtongji.vue'
import jmPlatformShebeitongjiHome from '@/components/home/jm/platform/shebeitongji.vue'
import jmPlatformGuanggaotongjiHome from '@/components/home/jm/platform/guanggaotongji.vue'
//jm广告管理员
import jmAdvguanggaotongjiHome from '@/components/home/jm/adv/adv.vue'
//加盟商
import allianceHome from '@/components/home/alliance/home.vue'
import allianceHome2 from '@/components/home/alliance/home2.vue'
import alliance1Tj from '@/components/home/alliance/alliance1.vue'
import alliance2Tj from '@/components/home/alliance/alliance2.vue'
import alliance3Tj from '@/components/home/alliance/alliance3.vue'

//运营商
import operHome from '@/components/home/oper/home.vue'
import operHome2 from '@/components/home/oper/home2.vue'
import oper1Tj from '@/components/home/oper/oper1.vue'
import oper2Tj from '@/components/home/oper/oper2.vue'
import oper3Tj from '@/components/home/oper/oper3.vue'

export default [{
	path: '/home',
	name: 'home',
	component: home,
	children: [{
		path: '/jmPlatform',
		name: 'jmPlatform',
		component: jmPlatform,
		children:[
			{
				path: '/jmPlatformShangpingtongjiHome',
				name: 'jmPlatformShangpingtongjiHome',
				component: jmPlatformShangpingtongjiHome,
			
			},{
				path: '/jmPlatformShebeitongjiHome',
				name: 'jmPlatformShebeitongjiHome',
				component: jmPlatformShebeitongjiHome,
			
			},{
				path: '/jmPlatformGuanggaotongjiHome',
				name: 'jmPlatformGuanggaotongjiHome',
				component: jmPlatformGuanggaotongjiHome,
			
			}
		]
	},{
		path: '/jmAdvguanggaotongjiHome',
		name: 'jmAdvguanggaotongjiHome',
		component: jmAdvguanggaotongjiHome
	},,{
		path: '/alliance',
		name: 'alliance',
		component: allianceHome,
		children:[
			{
				path: '/alliancetj1',
				name: 'alliancetj1',
				component: alliance1Tj,
			
			},{
				path: '/allianceHome2',
				name: 'allianceHome2',
				component: allianceHome2,
				children:[
					{
						path: '/alliancetj2',
						name: 'alliancetj2',
						component: alliance2Tj,
					
					},{
						path: '/alliancetj3',
						name: 'alliancetj3',
						component: alliance3Tj,
					
					}
				]
			}
		]
	},{
		path: '/oper',
		name: 'oper',
		component: operHome,
		children:[
			{
				path: '/opertj1',
				name: 'opertj1',
				component: oper1Tj,
			
			},{
				path: '/operHome2',
				name: 'operHome2',
				component: operHome2,
				children:[
					{
						path: '/opertj2',
						name: 'opertj2',
						component: oper2Tj,
					
					},{
						path: '/opertj3',
						name: 'opertj3',
						component: oper3Tj,
					
					}
				]
			}
		]
	}]
}]



// WEBPACK FOOTER //
// ./src/router/home/home.js